
angular.module('mtic.components.dashboards.student_general')
.component('studentClasses', {
  templateUrl: 'template.html',
  bindings: {
    onSelect: '<',
    isGreyed: '<',
  },
  controllerAs: 'studentClasses',
  controller($scope, $q, $log,$timeout, IAMManager, StudentDataService, EventManager, language, DEV_VARIABLES, api, Firebase, userAccount, LocaleService) {
    var eventManager = new EventManager('studentClasses', $scope);
    const studentClasses = this;
    studentClasses.classes = [];
    studentClasses.classesToGrey = [];
    studentClasses.classesToHide = [];

    var init = function(){
      getClasses();
    }

    function cycle_check(){
      var isLux = true//LocaleService.getCurrentLocale() === 'LUXEMBOURG';
      var user_id =  userAccount.getData().user_id;
      if(!LocaleService.hasTakenStudentCyclePrompt && isLux){
        var last_sept = moment(moment().year()+'-08-01').toDate()
        if(moment().month() < 7){
          last_sept = moment(moment().year()-1+'-08-01').toDate();
        }
        api.getUserResourceLatestAppState(user_id, 1248, last_sept).then( (app_logs)=>{
          var taken_cycle_prompt = false;
          var is_c4_memeber = false;
          if(app_logs && Object.keys(app_logs).length !== 0){
            taken_cycle_prompt = true;
            if(app_logs.app_state && app_logs.app_state.teacher_cycle_prompt && (app_logs.app_state.teacher_cycle_prompt.class_choice_c4_1 || app_logs.app_state.teacher_cycle_prompt.class_choice_c4_2)){
              is_c4_memeber = true;
            }
          }
          $log.log('app_logs : ', app_logs && app_logs.length, taken_cycle_prompt)

          LocaleService.hasTakenStudentCyclePrompt = taken_cycle_prompt;
          LocaleService.is_c4_student = is_c4_memeber;

          if(!taken_cycle_prompt){
            eventManager.broadcast("navbar:teacher-cycle:prompt");
          }
          
          //DONT REMOVE THIS - RE ADD WHEN QUESTIONNAIRE IS REENABLED // 2018-11-06: is this still relevant? (CA)

          //else if(is_c4_memeber && (!LocaleService.done_student_post_test || !LocaleService.done_student_offboarding)){

            // var token_saved_url = IAMManager.getSavedUrlParamsForToken();
            // // $log.log("Locale saved baseline/quest: ", LocaleService.hasCompletedStudentBase, LocaleService.hasCompletedStudentQuest)
            // eventManager.broadcast('C4_BASELINE_LOG', {
            //   isTeacher: false,
            //   isApp: window.isWebEmbedConnect || window.location.href.indexOf('web-embed-connect') !== -1 || token_saved_url.indexOf('web-embed-connect') !== -1,
            //   flag_baseline_check: LocaleService.hasCompletedStudentBase,
            //   flag_questionnaire_check:  LocaleService.hasCompletedStudentQuest
            // })

            // api.getUserResourceAppState(user_id,2890).then( (data)=>{
            //   if(!data || data.length === 0){
            //     eventManager.broadcast('navbar:teacher-test:click', {isStudentTest: true});
            //   }else{
            //     LocaleService.done_student_post_test = true;
            //     api.getUserResourceAppState(user_id,2893).then( (data)=>{
            //       if(!data || data.length === 0){
            //         eventManager.broadcast('navbar:teacher-test:click', {isStudentTest: true, isBaseline: true});
            //       }else{
            //         LocaleService.done_student_offboarding = true;
            //       }
            //     })
            //   }
            // })
          //}
        })
      }
      // else if(LocaleService.is_c4_student && (!LocaleService.done_student_post_test || !LocaleService.done_student_offboarding)){
      //   api.getUserResourceAppState(user_id,2890).then( (data)=>{
      //     if(!data || data.length === 0){
      //       eventManager.broadcast('navbar:teacher-test:click', {isStudentTest: true});
      //     }else{
      //       LocaleService.done_student_post_test = true;
      //       api.getUserResourceAppState(user_id,2893).then( (data)=>{
      //         if(!data || data.length === 0){
      //           eventManager.broadcast('navbar:teacher-test:click', {isStudentTest: true, isBaseline: true});
      //         }else{
      //           LocaleService.done_student_offboarding = true;
      //         }
      //       })
      //     }
      //   })
      // }
    }

    $scope.getTranslation = function(id){
      return language.get(id);
    }

    var getClasses = function(){
      studentClasses.isGettingClasses = true;
      studentClasses.classes_real = [];
      studentClasses.classes_teacherless = [];

      StudentDataService.getClasses()
      .then(function(classes){
        classes = classes.filter(function(cur_class){
          return !cur_class.archived
        })

        var teacherlessResourceMap = {};
        _.each(DEV_VARIABLES.GROUPS.LUXEMBOURG.TEACHERLESS_MODULES, function(resourceDef){
          teacherlessResourceMap[resourceDef.group_id] = true;
        });
        var resourceTypeCheck = {};
        var classes_real = [];
        var teacherlessResourceStore = {};
        _.each(classes, function(classroom){
          var isTeacherless = teacherlessResourceMap[classroom.id];
          if(isTeacherless){
            teacherlessResourceStore[classroom.resource_type] = classroom;
          }
          else{
            classes_real.push(classroom);
            resourceTypeCheck[classroom.resource_type] = true;
          }
        });
        var classes_teacherless = [];
        _.each(DEV_VARIABLES.GROUPS.LUXEMBOURG.TEACHERLESS_MODULES, function(resourceDef){
          if (!resourceTypeCheck[resourceDef.resource_type] && teacherlessResourceStore[resourceDef.resource_type]){
            classes_teacherless.push(teacherlessResourceStore[resourceDef.resource_type]);
          }
        });
        studentClasses.classes_real = classes_real;
        studentClasses.classes_teacherless = classes_teacherless;
        studentClasses.isGettingClasses = false;
        
        if(window.location.href.indexOf('open_item_link') > -1 && !LocaleService.item_link_opened){
          var urlParams = new window.URLSearchParams(window.location.hash.split('&amp;').join('&'));
          var found_matching_class = false;
          for(var i=0;i<studentClasses.classes_real.length;i++){
            var user_class = studentClasses.classes_real[i];
            if(user_class.module_resource_id+'' === urlParams.get('module_id')){
              found_matching_class = true;              
              studentClasses.selectClassroom(user_class.id)
              break;
            }
          }
          if(!found_matching_class){
            for(i=0;i<studentClasses.classes_teacherless.length;i++){
              var user_classless = studentClasses.classes_teacherless[i];
              if(user_classless.module_resource_id+'' === urlParams.get('module_id')){
                found_matching_class = true;
                studentClasses.selectClassroom(user_classless.id)
                break;
              }
            }
          }
          if(!found_matching_class){
            //display error              
            window.alert('No class found with a similar resource to the one you attempting to open')
          }
        }
      });
    }
    studentClasses.selectClassroom = function(class_id){
      studentClasses.onSelect(class_id);
    }
    studentClasses.getClassTypeCaption = function(moduleResourceType){
      return language.get(moduleResourceType);
    }
    studentClasses.joinClass = function(classCode){
      if(!classCode || classCode.length===0){
        return;
      }

      studentClasses.isJoiningClass = true;
      var registrationToken = StudentDataService.parseClassCode(classCode);
      StudentDataService.getClassInfo({class_id: registrationToken.classId})
      .then((classroomTo) => {
        var matchedResourceClass = null;
        var matched_module_id = null;
        // check for running class of same type
        _.each(studentClasses.classes_real, (classroom) => {
          if (!matchedResourceClass && classroomTo.resource_type === classroom.resource_type){
            matched_module_id = classroom.module_id
            matchedResourceClass = classroom;
          }
        })
        // check for teacherless class of same type
        if (!matchedResourceClass){
          _.each(studentClasses.classes_teacherless, (classroom) => {
            if (!matchedResourceClass && classroomTo.resource_type === classroom.resource_type){
              //DO WE WANT TO COPY PROGRESS FROM FAKE CLASSES ?
              matched_module_id = classroom.module_id
              matchedResourceClass = classroom;
            }
          })
        }

         if (!matchedResourceClass){
          matchedResourceClass = { id : 0}
          //throw new Error('Cannot transfer as no reference class: [SYSTEM: IF NEW CLASS TYPE, PROVIDE ALT REG METHOD]');
        }

        if(parseInt(matchedResourceClass.id) === parseInt(registrationToken.classId)){
          studentClasses.alreadyInClass = true;
          studentClasses.isJoiningClass = false;
          studentClasses.errorMessage = 28498;
          throw new Error('ROLE_TYPE_ALREADY_EXISTS')
        }

//        console.log('details :', matchedResourceClass, registrationToken)

        return StudentDataService.transferStudent({
          from_class_id: matchedResourceClass.id,
          teacher_id: registrationToken.teacherId,
          to_class_id: registrationToken.classId
        })
      })
      .then((data)=>{
        studentClasses.isProblemJoining = false;
        studentClasses.alreadyInClass = false;
        studentClasses.isJoiningClass = false;
        // $log.log('TRANSFER COMPLETE', data)
        init();
      })
      .catch((err) => {
        $log.error('TRANSFER FAILED', err);
        if(err.message === 'ROLE_TYPE_ALREADY_EXISTS'){
          studentClasses.alreadyInClass = true;
          studentClasses.errorMessage = 28498;
        }else if(err.message === 'SEARCH_NOT_FOUND'){
          studentClasses.alreadyInClass = true;
          studentClasses.errorMessage = 28499;
        }else if(err.message === 'CLASS_IS_ARCHIVED'){
          studentClasses.alreadyInClass = true;
          studentClasses.errorMessage = 'class_is_archived';
        }else{
          studentClasses.isProblemJoining = true;
          eventManager.broadcast('help:open:forced');
        }
        studentClasses.isJoiningClass = false;
      })
    }

    init();

  }
});
